import { createBrowserHistory } from "history";
export const history_NORENDER = createBrowserHistory();
